import { LoginForm } from 'components';

export const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
